import { useEffect, useState } from "react";
import yearlyEventsService, { premiosFestaJunina } from "../../../../domain/services/marketing/events/yearly.events.service";
import useRequest from "../../../../hooks/useRequest";
import transactionService from "../../../../domain/services/financial/transaction.service";
import loginService from "../../../../domain/services/login.service";
import { packages } from "../../../../domain/constant/marketing/product.constant";
import LoadingSpin from "../../../../components/LoadingSpin";
import Roulette from "../../../../components/marketplace/specialEvents/festaJunina/roulette";
import { Star } from "lucide-react";

export default function PostPurchaseRoulette({
    onClose = () => { },
    isInModal = false
}) {

    const user = loginService.getUserAuthentication();

    const currentEvent = yearlyEventsService.getCurrentEvent();

    const [findCustomerTransactions] = useRequest(transactionService.findByCustomerId);
    const [addRoulettePrize] = useRequest(transactionService.addTransactionPrize);

    const [loading, setLoading] = useState(true);
    const [lastTransaction, setLastTransaction] = useState(null);

    const checkToShow = async () => {
        setLoading(true);

        if (!currentEvent || currentEvent.key !== 'festaJunina')
            return false;

        const transactions = await findCustomerTransactions(user.customer.id);

        const lastTransaction = transactions[0] || null;

        if (!lastTransaction)
            return false;

        const isPremiumOrInfinity = [packages.infinity.id, packages.premium.id].includes(lastTransaction?.additionalInformation?.marketingProductId);

        const prizesWon = lastTransaction?.additionalInformation?.roulettePrizes || [];

        const canSpinRoulette = isPremiumOrInfinity && prizesWon.length < (lastTransaction?.additionalInformation?.packageAmount || 1);

        if (!canSpinRoulette)
            return false;

        setLastTransaction(lastTransaction);

        setLoading(false);

        return true;
    }

    useEffect(() => {
        checkToShow()
            .then(shouldShow => {
                if (!shouldShow)
                    onClose();
            });
    }, []);

    const handleSelectPrize = async (prize) => {
        await addRoulettePrize(lastTransaction.id, prize.key, 'festaJunina');
    }

    return (
        <div>
            {loading ? (
                <div className="w-full py-64 flex flex-col gap-3 items-center">
                    <LoadingSpin size="large" />
                    <div className="text-primary text-base font-semibold">Carregando...</div>
                </div>
            ) : (
                <div className="-mx-6">
                    <div className={isInModal ? '' : "py-8 md:px-6 md:py-12 xl:py-6"}>
                        <Roulette
                            prizes={premiosFestaJunina}
                            subtitle={(
                                <div className="flex justify-center">
                                    <span className="max-w-2xl">
                                        Você ganhou uma chance de girar nossa <span className="font-bold">Roleta da Sorte</span>
                                        {" "}e ganhar um prêmio incrível! Clique na
                                        {" "}<span className="inline-block translate-y-[2px] font-bold bg-white/20 px-2 py-1 rounded text-center"><Star className="-translate-y-1 inline text-white fill-white" /></span>
                                        {" "}para girar a roleta.
                                    </span>
                                </div>
                            )}
                            onSelectPrize={handleSelectPrize}
                            onFinish={onClose}
                            spinAmount={(lastTransaction?.additionalInformation?.packageAmount || 1) - (lastTransaction?.additionalInformation?.roulettePrizes?.length || 0)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}